import React, { FC, useContext } from 'react';

// Utils
import { ArrowDownIcon, ConfigContext } from '@velinsi/smp-widgets-ui';
import { getLabelValue } from '@sportal365/smp-widget-utils';
import { defaultHandleUserInteractionClick } from '@sportal365/smp-widget-utils/src/clickHandlers';

// Types
import { ISubscriberInfo } from '../../../../../../packages/types';
import { USER_INTERACTION } from '../../../../../../packages/constants/entityTypes';
import { SHOW_MORE_SUBSCRIBE_TYPE } from '../../../../../../packages/constants/subscribeTypes';

interface ShowMoreButtonProps {
  hasMoreData: boolean;
  setLimit: React.Dispatch<React.SetStateAction<number>>;
  initialLimit: number;
  handleSubscriptionClick?: (info: ISubscriberInfo, clickType: string) => void;
}

export const ShowMoreButton: FC<ShowMoreButtonProps> = ({ hasMoreData, setLimit, initialLimit, handleSubscriptionClick }) => {
  const { dataLabels } = useContext(ConfigContext);

  if (!hasMoreData) return null;

  const handleShowMoreClickAndSendSubscriptionEvent = () => {
    setLimit((prev) => prev + initialLimit);

    handleSubscriptionClick && defaultHandleUserInteractionClick(handleSubscriptionClick, USER_INTERACTION, SHOW_MORE_SUBSCRIBE_TYPE);
  };

  return (
    <div className='bg-rowBackgroundColor text-center p-4'>
      <button
        onClick={handleShowMoreClickAndSendSubscriptionEvent}
        className='text-hiContrast text-4 flex items-center justify-center my-0 mx-auto cursor-pointer'
      >
        <span className='underline'>{getLabelValue(dataLabels?.show_more, 'Show more')}</span>
        <ArrowDownIcon />
      </button>
    </div>
  );
};
